var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.58,
    height: 20.58,
    viewBox: "0 0 20.58 20.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.455,20.58H6.125A6.132,6.132,0,0,1,0,14.455V6.125A6.132,6.132,0,0,1,6.125,0h8.33A6.132,6.132,0,0,1,20.58,6.125v8.33A6.131,6.131,0,0,1,14.455,20.58Zm-8.33-18.5A4.047,4.047,0,0,0,2.082,6.125v8.33A4.047,4.047,0,0,0,6.125,18.5h8.33A4.047,4.047,0,0,0,18.5,14.455V6.125a4.047,4.047,0,0,0-4.042-4.043Z",
    transform: "translate(0)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M5.328,10.657a5.329,5.329,0,1,1,5.329-5.329A5.335,5.335,0,0,1,5.328,10.657Zm0-8.575A3.246,3.246,0,1,0,8.575,5.328,3.25,3.25,0,0,0,5.328,2.082Z",
    transform: "translate(4.961 4.961)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.286,
    cy: 1.286,
    r: 1.286,
    transform: "translate(14.332 3.675)",
    fill: "#0c4767"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.90c2e8c02b642811f459f73dca10a719.svg";
export { ForwardRef as ReactComponent };